import React, { useState, useEffect, useCallback } from "react";
import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card";
import axios from "axios";

const ProjectCardDummy = ({ name, description, gh, link, languages }) => {

    return (
        <Col xs={12} md={6}>
            <Card className="card shadow-lg p-3 mb-5 bg-white rounded">
                <Card.Body>
                    <Card.Title as="h5">{name}</Card.Title>
                    <Card.Text>{description} </Card.Text>
                    <CardButtons gh={gh} link={link} />
                    <hr />
                        <Language languages={languages} />
                </Card.Body>
            </Card>
        </Col>
    );
};

const CardButtons = ({ gh, link }) => {
    return (
        <>
            {link != "" &&
                <a
                    href={link}
                    target="_blank"
                    className="btn btn-outline-secondary mr-3"
                >
                    <i className="fa fa-globe" /> Site
                </a>
            }
            {gh != "" &&
            <a href={gh} target=" _blank" className="btn btn-outline-secondary">
                <i className="fab fa-github" /> Github Repo
            </a>}
            
        </>
    );
};

const Language = ({ languages }) => {

    return (
        <div className="pb-3">
            Languages/Technologies:{" "}
            {languages.map((language) => (
                    <p
                        key={language}
                        className="badge badge-light card-link"
                    >
                        {language}
                    </p>
                ))}
        </div>
    );
};

export default ProjectCardDummy;
